import { useCallback, useState, useEffect } from "react";
import { CiSearch } from "react-icons/ci";
import CommunityCard from "./Cards";
import { toast } from "react-toastify";
import { useDisclosure } from "@chakra-ui/react";
import {
  allCommunities,
  joinCommunity,
  searchCommunity,
  searchEvents,
} from "../../redux/api";
import { TailSpin } from "react-loader-spinner";

const Communities = ({ darktheme }) => {
  const [newDoc, setNewDoc] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [search] = useState("");
  const [event, setEvents] = useState([]);
  const { onClose } = useDisclosure();
  const [, setLoading] = useState(false);
  const [, setLoadingMore] = useState(false);
  const [community, setCommunity] = useState(null);
  const [loadingComm, setLoadingComm] = useState(false);
  const [, setIndex] = useState(2);
  const [load, setLoad] = useState(0);
  const [page] = useState(1);
  const [, setTotalPages] = useState(0);

  const getCommunities = useCallback(async () => {
    try {
      setLoadingComm(true);
      const { data } = await allCommunities(newDoc);
      if (data) {
        setNewDoc(data?.data?.lastDoc);
        setCommunity(data?.data?.communities);
        setLoadingComm(false);
        setLoadingMore(true);
      }
    } catch (error) {
      setLoadingComm(false);
    }
    setIndex((prevIndex) => prevIndex + 1);
  }, [load]);

  const submit = async (id) => {
    try {
      setLoading(true);
      const { data } = await joinCommunity(id);
      if (data) {
        setLoading(false);
        toast.success(data?.message);
        setLoad(load + 1);
        getCommunities();
        onClose();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    handleSearchCommunity(e.target.value);
  };

  const handleSearchCommunity = useCallback(
    async (searchTerm) => {
      setLoading(true);
      try {
        const { data } = await searchCommunity(searchTerm.trim(), page);
        if (data) {
          const transformCommunityData = (data) => {
            return data.hits.map((community) => {
              return {
                banned: community.document.banned,
                communityCode: community.document.communityCode,
                communityCoverPhoto: community.document.communityCoverPhoto,
                communityDesc: community.document.communityDesc,
                communityID: community.document.communityID,
                communityName: community.document.communityName,
                communityType: community.document.communityType,
                createdAt: community.document.createdAt,
                createdBy: community.document.createdBy,
                id: community.document.id,
                isMember: community.document.isMember,
                memberCount: community.document.memberCount,
                requestToJoin: community.document.requestToJoin,
              };
            });
          };
          const searchedCommunity = transformCommunityData(data);
          setNewDoc(data?.data?.lastDoc);
          setCommunity(searchedCommunity);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    },
    [page]
  );
  const visibleTodos = useCallback(() => {
    getCommunities(true);
  }, []);

  useEffect(() => {
    visibleTodos();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchTerm) {
        handleSearchCommunity(searchTerm);
      } else {
        getCommunities();
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm]);
  // }, [searchTerm, handleSearchCommunity, getCommunities]);

  return (
    <>
      {loadingComm ? (
        <div className="flex h-[50vh] items-center justify-center">
          <TailSpin
            visible={true}
            height="80"
            width="80"
            color="#000000"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <div>
          <div
            className={`flex items-center w-full h-[50px] mb-[1rem] px-5 ${
              darktheme ? "bg-[black]" : "bg-[#F9FAFB]"
            } rounded-[43px]`}
          >
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search Community"
              className="w-full h-full bg-transparent rounded-[43px] border-none outline-none"
            />
            <CiSearch
              size={24}
              className="cursor-pointer"
              onClick={handleSearchCommunity}
            />
          </div>
          {community?.length === 0 && (
            <p className="text-[#60646c]">No Communities found</p>
          )}
          {community &&
            community?.map((item) => (
              <CommunityCard data={item} join={submit} theme={darktheme} />
            ))}
        </div>
      )}
    </>
  );
};

export default Communities;
